var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('information-details',{attrs:{"title":'החודש הראשון ב-riseup בחינם!',"details":['משלמים רק מהחודש ה-2 לשימוש, ₪45 לחודש',
                    'בלי התחייבות, אפשר לבטל בכל רגע',
                    'לא צריך להכניס פרטי אשראי עד לסוף תקופת הניסיון']}})}
var staticRenderFns = []

export { render, staticRenderFns }